var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.3902,
    height: 64.3902,
    rx: 8,
    fill: "url(#paint0_linear_45_219)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6429 14L46.3571 44.3929L27.915 51L12 44.3929L13.6187 36.5634H20.3911L19.7304 39.9165L29.3437 43.5835L40.419 39.9165L41.9717 31.8971H14.4364L15.7578 25.1248H43.3179L44.185 20.7723H16.6498L17.996 14H51.6429V14Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_219",
    x1: -4.02439,
    y1: -6.03659,
    x2: 59.0244,
    y2: 72.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCss);
export default __webpack_public_path__ + "static/media/icon_css.6914743422bf70fad8d0ba73725b76e0.svg";
export { ForwardRef as ReactComponent };